import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'replaceLineBreaks'
})
export class ReplaceLineBreaksPipe implements PipeTransform
{
  public transform(value: string): string
  {
    return value ? value.replace(/\n/g, '<br/>') : value;
  }
}
